import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { NavbarComponent } from './navbar.component';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { PopupService } from '@mwe/services';
import { NgClass } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BadgeComponent } from '../../badge/badge/badge.component';

@Component({
  selector: 'mwe-navbar-footer',
  templateUrl: './navbar-footer.component.html',
  imports: [NgClass, RouterLink, TranslateDirective, RouterLinkActive, TranslatePipe, BadgeComponent],
})
export class NavbarFooterComponent extends NavbarComponent implements OnInit {
  private popupService = inject(PopupService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  backdrop: HTMLElement;
  isProfileOpen = signal<boolean>(false);
  userName = signal<string>(undefined);
  emailAddress = signal<string>(undefined);

  override async ngOnInit() {
    await super.ngOnInit();

    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationEnd && window['drawCutOut']) {
        setTimeout(window['drawCutOut'], 10);
      }
    });
    this.userName.set(this.accountLogic.getAccountFullName());
    this.emailAddress.set(this.accountLogic.getAccountEmail());
  }

  toggleProfile(): void {
    if (this.isProfileOpen()) {
      this.closeProfile();
      return;
    }
    this.isProfileOpen.set(true);
    this.backdrop = document.createElement('div');
    this.backdrop.classList.add('modal-backdrop', 'fade', 'show');
    this.backdrop.style.zIndex = '1';
    this.backdrop.addEventListener('click', () => {
      this.closeProfile();
    });
    document.body.append(this.backdrop);
  }

  closeProfile(): void {
    this.isProfileOpen.set(false);
    this.backdrop?.remove();
  }

  logout(): void {
    this.popupService.openLogoutPopup();
  }
}
